module.exports = __webpack_public_path__ + "static/media/timesheet_Details1.a0f9eee6.png";